import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'app-copy-button',
  templateUrl: './copy-button.component.html',
  styleUrls: ['./copy-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NzButtonModule, NzToolTipModule, NzIconModule],
})
export class CopyButtonComponent {
  @Input() text?: string = '';
  @Input() tooltip: string = 'Copy';

  constructor(private messageService: NzMessageService) {}

  onClick() {
    navigator.clipboard.writeText(this.text ?? '');

    this.messageService.success(`Copied: ${this.text ?? ''}`);
  }
}
